export default __webpack_public_path__ + "static/Plots0047-739b23f5e46d6526e0c3316aa67f5456.jpg";